export enum GatewayOPEEnum {
  PutGateway = 'putGateway',
  PutGatewayLegacy = 'putGatewayLegacy',
  DelGateway = 'delGateway',
  GetFlashedGateways = 'getFlashedGateways',
  // ProvisionGateway = 'provisionGateway',
  SendGatewayDevicesConfig = 'sendGatewayDevicesConfig',
  AssignGateway = 'assignGateway',
  ReplaceGateway = 'replaceGateway',
  DismissGateway = 'dismissGateway',
  GetNetInterfacePassword = 'getNetInterfacePassword'
}
